var _MenuIcon, _IngramLogoWithoutR, _IngramLogoLogOutWith, _IngramLogoWithoutR2, _IngramLogoLogOutWith2;
import React from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import MenuIcon from '@mui/icons-material/Menu';
import { HeaderUserActions } from './internal/HeaderUserActions';
import { ImpersonationHeader } from './internal/ImpersonationHeader';
import { IngramLogoWithoutR } from '../icons/IngramLogoWithoutR';
import { useIsDown } from '../responsive';
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from 'react-router';
import { useLocalization, useTranslate } from '@im/react-localization';
import Typography from '@mui/material/Typography';
import { ProductSearchAutocomplete } from './internal/ProductSearchAutocomplete';
import { CulturePickerNew } from '../CulturePicker/CulturePickerNew';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/max-dependencies
import { IngramLogoLogOutWithoutR } from '../icons/IngramLogoLogOutWithoutR';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Header(props) {
  var AvatarProps = props.AvatarProps,
    NotificationProps = props.NotificationProps,
    billingModeSelector = props.billingModeSelector,
    cartItemsCount = props.cartItemsCount,
    _props$closeInsightsD = props.closeInsightsDrop,
    closeInsightsDrop = _props$closeInsightsD === void 0 ? false : _props$closeInsightsD,
    _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    _props$disableCartIco = props.disableCartIcon,
    disableCartIcon = _props$disableCartIco === void 0 ? false : _props$disableCartIco,
    _props$enableAISugges = props.enableAISuggestions,
    enableAISuggestions = _props$enableAISugges === void 0 ? false : _props$enableAISugges,
    endUserIcon = props.endUserIcon,
    endUserTitle = props.endUserTitle,
    getSearchSuggestions = props.getSearchSuggestions,
    _props$hasInsightData = props.hasInsightData,
    hasInsightData = _props$hasInsightData === void 0 ? null : _props$hasInsightData,
    impersonationHeaderProps = props.impersonationHeaderProps,
    insightsContent = props.insightsContent,
    isAuthenticated = props.isAuthenticated,
    isCmpWhitelisted = props.isCmpWhitelisted,
    isEndUserLogin = props.isEndUserLogin,
    _props$isLogoClickabl = props.isLogoClickable,
    isLogoClickable = _props$isLogoClickabl === void 0 ? true : _props$isLogoClickabl,
    onMenuButtonClick = props.onMenuButtonClick,
    onUserActionClick = props.onUserActionClick,
    _props$page = props.page,
    page = _props$page === void 0 ? '' : _props$page,
    quoteItemsCount = props.quoteItemsCount,
    setIsInsightsButtonClicked = props.setIsInsightsButtonClicked,
    setIsInsightsDropOpen = props.setIsInsightsDropOpen,
    _props$showAvatar = props.showAvatar,
    showAvatar = _props$showAvatar === void 0 ? true : _props$showAvatar,
    _props$showCartIcon = props.showCartIcon,
    showCartIcon = _props$showCartIcon === void 0 ? true : _props$showCartIcon,
    _props$showCulturePic = props.showCulturePicker,
    showCulturePicker = _props$showCulturePic === void 0 ? true : _props$showCulturePic,
    _props$showFavoritesI = props.showFavoritesIcon,
    showFavoritesIcon = _props$showFavoritesI === void 0 ? true : _props$showFavoritesI,
    _props$showImpersonat = props.showImpersonationHeader,
    showImpersonationHeader = _props$showImpersonat === void 0 ? false : _props$showImpersonat,
    _props$showInsightsIc = props.showInsightsIcon,
    showInsightsIcon = _props$showInsightsIc === void 0 ? true : _props$showInsightsIc,
    _props$showNotificati = props.showNotificationIcon,
    showNotificationIcon = _props$showNotificati === void 0 ? true : _props$showNotificati,
    _props$showQuoteIcon = props.showQuoteIcon,
    showQuoteIcon = _props$showQuoteIcon === void 0 ? false : _props$showQuoteIcon,
    _props$showSeachBar = props.showSeachBar,
    showSeachBar = _props$showSeachBar === void 0 ? true : _props$showSeachBar,
    sx = props.sx;
  var isDownLg = useIsDown('lg', true);
  var showMenuIcon = isDownLg;
  var navigate = useNavigate();
  var _useLocalization = useLocalization(),
    translate = _useLocalization.translate;
  var ariaLabelTranslate = useTranslate();
  var location = useLocation();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(RootStack, {
      alignContent: "center",
      direction: "row",
      sx: sx,
      "data-element": "RootStack",
      "data-source-file": "Header.tsx",
      children: [/*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        spacing: 2,
        "data-element": "Stack",
        "data-source-file": "Header.tsx",
        children: [showMenuIcon && !showImpersonationHeader && /*#__PURE__*/_jsx(StyledIcon, {
          "aria-label": ariaLabelTranslate('Common.Menu'),
          color: "primary",
          onClick: onMenuButtonClick,
          children: _MenuIcon || (_MenuIcon = /*#__PURE__*/_jsx(MenuIcon, {
            height: "24px !important",
            width: "24px !important"
          }))
        }), /*#__PURE__*/_jsxs(Stack, {
          alignItems: "center",
          direction: "row",
          "data-element": "Stack",
          "data-source-file": "Header.tsx",
          children: [isLogoClickable ? /*#__PURE__*/_jsx(StyledLink, {
            "aria-label": ariaLabelTranslate('Common.GoToHomePage'),
            to: "/home",
            children: isAuthenticated ? _IngramLogoWithoutR || (_IngramLogoWithoutR = /*#__PURE__*/_jsx(IngramLogoWithoutR, {
              height: "24px",
              width: "242px"
            })) : _IngramLogoLogOutWith || (_IngramLogoLogOutWith = /*#__PURE__*/_jsx(IngramLogoLogOutWithoutR, {
              height: "24px",
              width: "242px"
            }))
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: isAuthenticated ? _IngramLogoWithoutR2 || (_IngramLogoWithoutR2 = /*#__PURE__*/_jsx(IngramLogoWithoutR, {
              height: "24px",
              width: "242px"
            })) : _IngramLogoLogOutWith2 || (_IngramLogoLogOutWith2 = /*#__PURE__*/_jsx(IngramLogoLogOutWithoutR, {
              height: "24px",
              width: "242px"
            }))
          }), isEndUserLogin && endUserIcon && endUserIcon, isEndUserLogin && endUserTitle && /*#__PURE__*/_jsx(Typography, {
            fontSize: 14,
            fontWeight: 600,
            padding: 1,
            sx: {
              display: 'inline-block',
              marginLeft: '0.5px',
              maxWidth: '20ch',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            },
            children: endUserTitle
          })]
        })]
      }), isAuthenticated && billingModeSelector, showSeachBar && /*#__PURE__*/_jsx(ProductSearchAutocomplete, {
        "data-testid": testid,
        enableAISuggestions: enableAISuggestions,
        getSearchSuggestions: getSearchSuggestions,
        isCmpWhitelisted: isCmpWhitelisted
      }), isAuthenticated && /*#__PURE__*/_jsx(HeaderUserActions, {
        AvatarProps: AvatarProps,
        NotificationProps: NotificationProps,
        cartItemsCount: cartItemsCount,
        closeInsightsDrop: closeInsightsDrop,
        "data-testid": testid,
        disableCartIcon: disableCartIcon,
        hasInsightData: hasInsightData,
        insightsContent: insightsContent,
        onUserActionClick: onUserActionClick,
        page: page,
        quoteItemsCount: quoteItemsCount,
        setIsInsightsButtonClicked: setIsInsightsButtonClicked,
        setIsInsightsDropOpen: setIsInsightsDropOpen,
        showAvatar: showAvatar,
        showCartIcon: showCartIcon,
        showCulturePicker: showCulturePicker && !showImpersonationHeader,
        showFavoritesIcon: showFavoritesIcon,
        showInsightsIcon: showInsightsIcon,
        showNotificationIcon: showNotificationIcon,
        showQuoteIcon: showQuoteIcon
      }), isAuthenticated && showImpersonationHeader && impersonationHeaderProps && /*#__PURE__*/_jsx(ImpersonationHeader, {
        alertMessage: impersonationHeaderProps == null ? void 0 : impersonationHeaderProps.alertMessage,
        alertSeverity: impersonationHeaderProps == null ? void 0 : impersonationHeaderProps.alertSeverity,
        enableLogoutButton: impersonationHeaderProps == null ? void 0 : impersonationHeaderProps.enableLogoutButton,
        exitButtonDisabled: impersonationHeaderProps == null ? void 0 : impersonationHeaderProps.exitButtonDisabled,
        exitButtonLoading: impersonationHeaderProps == null ? void 0 : impersonationHeaderProps.exitButtonLoading,
        exitButtonText: impersonationHeaderProps == null ? void 0 : impersonationHeaderProps.exitButtonText,
        logoutButtonText: translate('Navigation.LogOut'),
        onExitButtonClick: impersonationHeaderProps == null ? void 0 : impersonationHeaderProps.onImpersonationButtonClick,
        onLogoutButtonClick: AvatarProps == null ? void 0 : AvatarProps.onLogoutClick
      }), !isAuthenticated && /*#__PURE__*/_jsxs(Stack, {
        alignContent: "right",
        direction: "row",
        spacing: "1.286rem",
        children: [/*#__PURE__*/_jsx(CulturePickerNew, {
          "data-testid": testid
        }), /*#__PURE__*/_jsx(Button, {
          "data-testid": "btn_TopCornerLogin",
          onClick: function onClick() {
            return navigate('/login', {
              state: {
                from: location
              }
            });
          },
          sx: {
            height: '32px',
            padding: '6px 12px'
          },
          variant: "contained",
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "bodycopyregular",
            children: translate('OktaWidget.PrimaryAuthSubmit')
          })
        })]
      })]
    })
  });
}
var RootStack = styled(Stack)(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(theme.palette.grey[200]),
    height: '52px',
    justifyContent: 'space-between',
    padding: '0px 16px'
  };
});
var StyledLink = styled(Link)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    alignItems: 'center',
    display: 'flex'
  };
});
var StyledIcon = styled(IconButton)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    '& .MuiSvgIcon-root': {
      fontSize: '24px'
    }
  };
});